import { useState } from 'react';
import config from 'config';
import Image from 'next/image';

import { Box, Flex, Stack, Text, useBoolean, useTheme } from '@chakra-ui/react';

import { ProviderInterface } from 'types';

import { Loader } from 'ui';

const {
  booking: { defaultProvider, DefaultProviderAvatar }
} = config;

interface ProviderItemProps {
  provider: ProviderInterface | null;
}

const ProviderItem = ({ provider }: ProviderItemProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepTime: {
            apptDetailsList: { detailsItem }
          }
        }
      }
    }
  } = useTheme();

  const [imageError, setImageError] = useState<boolean>(false);
  const [loading, setLoading] = useBoolean(true);

  const isDefaultProvider = provider?.id === defaultProvider.id;
  const providerName = isDefaultProvider
    ? defaultProvider.name
    : provider?.name;
  const providerDescription = isDefaultProvider
    ? defaultProvider.description
    : provider?.public_title;

  return (
    <Flex w='100%' alignItems='center' gap='10px'>
      <Box
        w='40px'
        h='40px'
        borderRadius='50%'
        overflow='hidden'
        position='relative'
        flexShrink={0}
      >
        {provider?.public_photo_url?.includes('http') && !imageError ? (
          <>
            {loading && <Loader absolute />}
            <Image
              src={provider?.public_photo_url}
              alt={provider?.name || 'Provider name'}
              sizes='(max-width: 450px) 40px, 65px'
              width={40}
              height={40}
              onError={() => setImageError(true)}
              onLoad={setLoading.off}
            />
          </>
        ) : (
          <DefaultProviderAvatar
            width={40}
            height={40}
            fill={detailsItem.providerIconColor}
            style={{ opacity: 0.5 }}
          />
        )}
      </Box>

      <Stack gap='2px' justifyContent='center'>
        <Text
          color={detailsItem.providerNameTextColor}
          fontSize='16px'
          textTransform='uppercase'
        >
          {providerName}
        </Text>

        {providerDescription && (
          <Text
            color={detailsItem.providerDescriptionTextColor}
            fontSize='12px'
            mt='5px'
          >
            {providerDescription}
          </Text>
        )}
      </Stack>
    </Flex>
  );
};

export default ProviderItem;
